import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as Common from 'common/components';

class FileRow extends PureComponent {
  static propTypes = {
    file: PropTypes.object.isRequired,
    handleRemove: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleRemove = (e) => {
    e.preventDefault();
    this.props.handleRemove(this.props.id);
  };

  state = { preview: null };

  render = () => (
    <tr>
      <td className="text-center align-middle">
        <Common.File file={this.props.file} />
      </td>
      <td className="align-middle">{this.props.file.name}</td>
      <td className="align-middle text-center">{this.props.t('files.uploaded')}</td>
      <td className="align-middle">
        <button className="btn btn-danger btn-sm" onClick={this.handleRemove}>
          {this.props.t('actions.delete')}
        </button>
      </td>
    </tr>
  );
}

export default translate()(FileRow);



// WEBPACK FOOTER //
// src/modules/common/components/files/FileRow.js